function getLinks(data) {
  return data.items
    .map((item) => {
      const title = item.Title;
      const href = item.URL;
      const target = item.URLOpenInANewWindow ? ' target="_blank"' : '';

      return `<a href="${href}"${target}>${title}</a>`;
    })
    .join('');
}

export default function () {
  const widgetName = 'cardWidgetHeaderLinks';
  const widgetOpts = cardWidgetHeaderLinksOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      if (hasData) {
        $(`#${widgetName}`).html(getLinks(data));
      } else {
        $(`#${widgetName}`).hide();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false,
  });
}
